import React from "react";
import { FaEdit } from "react-icons/fa";
function Edit({id,handleEdit}) {
  return (
    <>
      <button
        onClick={() => handleEdit(id)}
        className="p-2 text-green-600 hover:bg-green-100 rounded-lg transition-all duration-200 hover:scale-110"
        title="Edit"
      >
        <FaEdit className="w-4 h-4" />
      </button>
    </>
  );
}

export default Edit;
